<div class="page-layout">
  <app-page-header title="Prompt Snippets">
    <app-back-link to="/settings" label="Settings"></app-back-link>
  </app-page-header>

  <app-loading-spinner *ngIf="isLoading"></app-loading-spinner>

  <div class="message error-message" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="message success-message" *ngIf="successMessage">{{ successMessage }}</div>

  <div class="content-container" *ngIf="!isLoading">
    <div class="prompt-section">
      <div class="prompt-header">
        <h3>User Profile</h3>
        <p class="description">Define your fishing persona. This replaces the location-specific areas in all system prompts.</p>
      </div>
      <div class="prompt-input-group">
        <span class="prompt-prefix">The user is</span>
        <app-resizable-textarea
          [(ngModel)]="userProfile"
          [minRows]="2"
          placeholder="e.g., a kayak fisherman fishing on the western shore of the chesapeake">
        </app-resizable-textarea>
      </div>
    </div>

    <div class="prompt-section">
      <div class="prompt-header">
        <h3>Known Waters</h3>
        <p class="description">List the areas that you fish. This is added to all system prompts to help the AI identify specific locations.</p>
      </div>
      <div class="prompt-input-group">
        <app-resizable-textarea
          [(ngModel)]="knownWaters"
          [minRows]="2"
          placeholder="e.g., Whitehall Creek, Whitehall Bay, Rideout Creek, Minnow Creek, Homewood Cove, Meredith Creek">
        </app-resizable-textarea>
      </div>
    </div>

    <div class="prompt-section">
      <div class="prompt-header">
        <h3>Rules</h3>
        <p class="description">Additional rules or preferences for the AI to follow in all system prompts.</p>
      </div>
      <div class="prompt-input-group">
        <app-resizable-textarea
          [(ngModel)]="rules"
          [minRows]="2"
          placeholder="e.g., Keep reports short and concise. Do not mention barometric pressure.">
        </app-resizable-textarea>
      </div>
    </div>

    <div class="action-bar">
      <button 
        mat-flat-button 
        color="primary" 
        (click)="saveAll()" 
        [disabled]="isSaving"
        class="save-button">
        <mat-spinner *ngIf="isSaving" diameter="20" class="save-spinner"></mat-spinner>
        <span>{{ isSaving ? 'Saving...' : 'Save All Snippets' }}</span>
      </button>
    </div>
  </div>
</div>
